import { noop } from "@common/helpers/function";
import { NewVersionAvailableContextValue } from "./NewVersionAvailableContext";

export const newVersionAvailableProxy: Pick<
    NewVersionAvailableContextValue,
    "notifyNewVersionAvailable"
> = {
    notifyNewVersionAvailable: noop,
};
